var map = {
	"./account-delete.svg": 80699,
	"./accounts.svg": 25140,
	"./auxiliary_inspection.svg": 20709,
	"./back.svg": 96169,
	"./backTop.svg": 74014,
	"./change-mobile-phone-number.svg": 85666,
	"./circle.svg": 51124,
	"./collection.svg": 58060,
	"./comment.svg": 79279,
	"./consultation.svg": 90567,
	"./correct.svg": 87162,
	"./delete.svg": 78185,
	"./diagnosis.svg": 97047,
	"./error_red.svg": 69750,
	"./guide.svg": 88744,
	"./huodong.svg": 82186,
	"./image.svg": 85991,
	"./live.svg": 36590,
	"./message.svg": 82453,
	"./mine_task.svg": 18243,
	"./mistake.svg": 48632,
	"./more.svg": 53915,
	"./ph--subtitles-bold-hide.svg": 784,
	"./ph--subtitles-bold-show.svg": 24067,
	"./physical_examination.svg": 31881,
	"./recall-gift.svg": 68802,
	"./recall-live.svg": 75662,
	"./shouhou.svg": 6391,
	"./signout-user.svg": 56447,
	"./success-icon.svg": 29541,
	"./success_green.svg": 76957,
	"./thumbs-up.svg": 88107,
	"./treatment.svg": 35428,
	"./unfold.svg": 52592,
	"./warning.svg": 4476,
	"./yaodian.svg": 31073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51267;